/**
 * Venues whose admin SVG seatmap should match box-office SVG seat sizing.
 * Kept in sync with frontend `sectionCoverVenues.js`.
 */
const SLUG_SUBSTRINGS = ["nmsu", "aggie", "pan-american"];
const AGGIE_MEMORIAL_STADIUM_SEAT_SCALE = 0.88;

function normalizeVenueText(value) {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
}

export function isNmsuStyleSeatmapVenue(venueSlug) {
  const s = normalizeVenueText(venueSlug);
  return SLUG_SUBSTRINGS.some((frag) => s.includes(frag));
}

export function getVenueSeatScale({ venueName, venueSlug } = {}) {
  const name = normalizeVenueText(venueName);
  if (name === "aggie memorial stadium") {
    return AGGIE_MEMORIAL_STADIUM_SEAT_SCALE;
  }

  return isNmsuStyleSeatmapVenue(venueSlug) ? 0.95 : undefined;
}
